import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import TableCell from '@material-ui/core/TableCell';

/**
 * @Description This function lets you return Actions component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
export default function Action({library}) {
    const {t} = useTranslation();
    const initialActions = useRef();
    const [checked, setChecked] = useState([]);

    useEffect(() => {
        let state = [];
        const libVersions = library.library_versions[library.library_versions.length - 1];
        for (const item of libVersions.actions) {
            state.push({action_name: item.action_name, selected: item.roles.length > 0, id: item.id});
        }
        initialActions.current = JSON.parse(JSON.stringify(state));
        setChecked(state);
    }, []);

    const setDifference = () => {
        let willBeAdded = [], willBeDeleted = [];
        for (let i = 0; i < checked.length; i++) {
            if (checked[i].selected !== initialActions.current[i].selected) {
                if (checked[i].selected) {
                    willBeAdded.push(initialActions.current[i].id);
                } else {
                    willBeDeleted.push(initialActions.current[i].id);
                }
            } else {
                let index = willBeAdded.indexOf(initialActions.current[i].id);
                if (index > -1) {
                    willBeAdded.splice(index, 1);
                }
                index = willBeDeleted.indexOf(initialActions.current[i].id);
                if (index > -1) {
                    willBeDeleted.splice(index, 1);
                }
            }
        }
        library.willBeAdded = willBeAdded;
        library.willBeDeleted = willBeDeleted;
    }

    const handleChange = (e, action) => {
        action.selected = e.target.checked;
        setDifference();
        setChecked([...checked]);
    }

    const handleSelect = () => {
        for (const item of checked) {
            item.selected = true;
        }
        setDifference();
        setChecked([...checked]);
    }

    const handleDeselect = () => {
        for (const item of checked) {
            item.selected = false;
        }
        setDifference();
        setChecked([...checked]);
    }

    return (
        <React.Fragment>
            <TableCell style={{width: 130}}>
                <button className="role-toggle-all" onClick={handleSelect}>{t('CONTENT.ROLE.SELECT-ALL')}</button>
            </TableCell>
            <TableCell style={{width: 130}}>
                <button className="role-toggle-all" onClick={handleDeselect}>{t('CONTENT.ROLE.DESELECT-ALL')}</button>
            </TableCell>
            <TableCell>
                <div className="role-action-inputs">{checked.map((action, actionI) => {
                    return (
                        <React.Fragment key={actionI}>
                            <input id={'role-action-' + library.library_name + '-' + actionI} type="checkbox"
                                   checked={action.selected} value={action.action_name} onChange={(e) => {
                                handleChange(e, action)
                            }}/>
                            <label className="role-action"
                                   htmlFor={'role-action-' + library.library_name + '-' + actionI}>{action.action_name}</label>
                        </React.Fragment>
                    );
                })}
                </div>
            </TableCell>
        </React.Fragment>
    );
}
